import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { SearchState } from '@/reducers/search';
import { isSearchSaved } from '@/shared/helpers/SavedSearches/matcher';
import { mapToSavedSearch } from '@/shared/helpers/SavedSearches/stateTranslator';
import type { SnackBarState } from '..';
import type { DisplayStrategyCallback } from '.';

export function create(state: SnackBarState): DisplayStrategyCallback {
  return (search: SearchState, filtersConfig: FiltersConfigState) => {
    return Promise.resolve(
      state.firstFetchDone &&
        !isSearchSaved(
          mapToSavedSearch(search, filtersConfig),
          state.savedSearchesIndex || {}
        )
    );
  };
}
